import styled from 'styled-components';
import { Card } from 'components/Card/styles';
// import { Wapper } from 'components/Spinner/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-stretch;
  height: 100%;
  padding: 0;
  margin: 0;
  nav {
    display: flex;
    justify-content: space-between;
    > button {
      width: 220px;
      svg {
        margin-right: 10px;
      }
    }
    > div {
      width: 220px;
    }
  }
`;
export const ColumnContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const Grafico = styled(Card)`
  margin: 10px;
  //Width fixada para que o menu não empurre os gráficos para fora da tela
  width: calc(50vw - 80px);
  align-items: center;
  p {
    margin: 10px 0;
  }
`;
// export const Spinner = styled(Wapper)`
//   margin: auto;
// `;
